import { Col, Table } from "react-bootstrap";
import BidQuickAdd from "./bidquickadd";
import BidItem from "./biditem";

const BidPanel = ({fields,setFields,actionTypes = []}) => {
    const remove = (id) => {
        setFields((prev) => prev.filter(item => item.id !== id));
    }

    const update = (id, data) => {
        setFields(prev => 
            prev.map(item => (item.id === id ? {...item,...data} : item))
        );
    }

    const prepend = (obj) => {
        setFields([obj, ...fields]);
    }
    
    return(
        <Col xs={12}>
            <h5 className="text-center">Bids</h5>
            <Table hover striped responsive size="sm" bordered>
                <thead>
                    <tr>
                        <th>Bid Upload</th>
                        <th>Bid Amount</th>
                        <th>Action</th>
                        <th>Check Upload</th>
                        <th>Final Amount</th>
                        <th>Comments</th>
                        <th>Last Modified Date</th>
                        <th>Last Modified By</th>
                        <th style={{width: '1%'}}>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <BidQuickAdd ActionTypes={actionTypes} prepend={prepend} />
                    {
                        fields.map((item) => (
                            <BidItem 
                                key={item.id}
                                bid={item}
                                actionTypes={actionTypes}
                                remove={remove}
                                update={update}
                            />
                        ))
                    }
                </tbody>
            </Table>
        </Col>
    )
}

export default BidPanel;